import React, { useState, useEffect } from "react";
//import "./styles.css";
import { Row, Col, Form, Button } from "react-bootstrap";
// import LeftpanelMember from "../../../components/leftpanel/left-panel-admin";
// import HeaderPart from "../../../components/layout/header-admin/header";
import "./bulkuploadcertificate.css";
import { CertDet2 } from "../../../assets/images";
import axios from "../../../axios/axios";
import { message } from "antd";
import LoadingOverlay from "react-loading-overlay";
import DataTable from "react-data-table-component";
import sampleFile from "../../../assets/sample-bulk-upload-code.csv";
import moment from "moment";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import Alert from "react-bootstrap/Alert";
import { CSVLink } from "react-csv";
import { DATE_FORMAT } from "../../../constants/constants";
import { adminConfig } from "../../../utils/adminConfig";

const BulkUpload = () => {
  const params = useParams();
  const certificate_id = params.certificate_id;
  const [loading, setLoading] = useState(false);
  const [dublicateMsg, setDublicateMsg] = useState("");
  const [dublicateMsgShow, setDublicateMsgShow] = useState(false);
  const [file, setFile] = useState("");
  const [certis, setCertis] = useState([]);
  const [allCodes, setallCodes] = useState([]);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [search, setSearch] = useState("");
  const [pagination, setPagination] = useState({
    limit: 5,
    page: 1,
    totalPage: 7,
    totalRows: 10,
  });
  const [query, setQuery] = useState("");
  const [certi, setCerti] = useState({
    certificateId: "",
    certificateTitle: "",
    certificateDesc: "",
    certificatePrice: "",
    defaultMsg: "",
    expiryAt: new Date(),
    certificateImg: "",
    certificateTerms: "",
    certificatePaymentUrl: "",
    certificateFinePrint: "",
    certificateLogo: "",
    redirectionUrl: "",
    certificateEmbeddedCode: "",
    certificateSecretCode: "",
  });
  const [csvData, setCsvData] = useState([]);

  useEffect(() => {
    getCertis();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    getAllCertificateCode();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, limit, search]);

  const getCertis = async () => {
    setLoading(true);

    axios
      .get(`/all-admin-certificates`, adminConfig())
      .then((res) => {
        if (res.data.status === true) {
          // message.success("fetched certis success");
          setCertis(res.data.data);
          // setPagination(res.data.pagination);
          if (certificate_id && certificate_id != "") {
            for (let index = 0; index < res.data.data.length; index++) {
              if (certificate_id == res.data.data[index].certificateId) {
                setCerti(res.data.data[index]);
                break;
              }
            }
          }
          setLoading(false);
        } else {
          message.error("Data Not Found");
          setLoading(false);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.error(err);
      });
  };

  const handleChange = (data) => {
    setCerti(certis[data]);
  };

  const uploadBadge = async (e) => {
    e.preventDefault();
    setLoading(true);

    let data = new FormData();
    if (file) {
      if (file.type === "text/csv") {
        data.append("csv", file);
        data.append("certificateId", certi._id);
        data.append("certificateIdentity", certi.certificateId);

        await axios
          .post(`/add-bulk-certis`, data, adminConfig())
          .then((res) => {
            setLoading(false);
            if (res.data.status === true) {
              message.success("added members success");
              getAllCertificateCode();
              setFile("");
              if (res?.data?.dublicateData?.length > 0) {
                setDublicateMsg(
                  `We have identified and counted duplicate entries in the CSV file. A total of ${res.data.dublicateData.length} duplicates will be removed before the data is inserted into the database. Please ensure that the data integrity is maintained.`
                );
                setDublicateMsgShow(true);
                setTimeout(() => {
                  setDublicateMsgShow(false);
                }, 12000);
              }
            } else {
              message.error("failed adding members");
            }
          })
          .catch((err) => {
            setLoading(false);
            console.error(err);
          });
        setLoading(false);
      } else {
        setLoading(false);
        message.error("Only CSV file supported!");
        console.error("error");
      }
    } else {
      setLoading(false);
      message.error("Please select csv file");
      console.error("error");
    }
  };

  const handlePerRowsChange = (newPerPage) => {
    setLimit(newPerPage);

    setPage(1);
  };
  const changePage = (newPage) => {
    setPage(newPage);
  };

  const getAllCertificateCode = () => {
    setLoading(true);

    axios
      .get(
        `/get-all-certificate-codes?limit=${limit}&page=${page}&search=${search}`
      )
      .then((res) => {
        setLoading(false);
        if (res.data.status) {
          let allData = [];
          let filterCertificate = res.data.data?.map((item) => {
            console.log(item, "item");
            //  if( item.certificateIdentity != "TVICRUISEVACAY"){
            allData.push(item);
            //  }
          })


          setallCodes(allData || []);
          setPagination(res.data.pagination);
        } else {
          message.error(res.data.message);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.error(err);
        message.error("Something went wrong");
      });
  };

  const columns = [
    {
      name: "Certificate ID",
      selector: (row) => row.certificateIdentity,
    },
    {
      name: "Certificate Code",
      selector: (row) => row.certificateEmbeddedCode,
    },
    {
      name: "Certificate Secret Code",
      selector: (row) => row.certificateSecretCode,
    },
    {
      name: "Certificate Status",
      selector: (row) => (row.activeStatus ? "Active" : "Inactive"),
      sortable: true,
    },
    {
      name: "Created Date",
      selector: (row) => moment(row.createdAt).format(DATE_FORMAT),
      sortable: true,
    },
  ];

  const exportCSV = () => {
    setLoading(true);
    axios
      .get(`/get-all-csv-certificate-codes?search=${search}`)
      .then((res) => {
        setLoading(false);
        if (res.data.status) {
          const csvData = res.data.data.map((member) => ({
            CertificateID: member.certificateIdentity,
            CertificateCode: member.certificateEmbeddedCode,
            CertificateSecretCode: member.certificateSecretCode,
            CertificateStatus: member.activeStatus ? "Active" : "Inactive",
            CreatedAt: moment(member.createdAt).format("Do MMM YYYY"),
          }));
          setCsvData(csvData);
          setTimeout(() => {
            document.getElementById("csv-download-link").click();
            setLoading(false);
          }, 2000);
        } else {
          message.error(res.data.message);
        }
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  const csvHeaders = [
    { label: "Certificate ID", key: "CertificateID" },
    { label: "Certificate Code", key: "CertificateCode" },
    { label: "Certificate Secret Code", key: "CertificateSecretCode" },
    { label: "Certificate Status", key: "CertificateStatus" },
    { label: "Created At", key: "CreatedAt" },
  ];

  return (
    <LoadingOverlay active={loading} spinner text="Loading ...">
      <div className="right_cont">
        <div className="right_banner_banner_cnt">
          <div className="travel_deals_admin">
            <h2>Hello, Admin!</h2>

            <div className="add_certificate">
              <div className="addcert_box1">
                <Row>
                  {dublicateMsgShow ? (
                    <>
                      <Col lg="12">
                        <Alert key="warning" variant="warning">
                          {dublicateMsg}
                        </Alert>
                      </Col>
                    </>
                  ) : (
                    <></>
                  )}
                  <Col lg="12" md="12" sm="12">
                    <Form.Group className="mb-3" controlId="formBasicEmail">
                      {/* <Form.Control
                                                as="select"
                                                custom
                                                className='text_link bulk_select'
                                                >
                                                <option>Select</option>
                                                <option>CSV</option>
                                                <option>Green</option>
                                                <option>Black</option>
                                                <option>Orange</option>
                                            </Form.Control> */}
                      <h3>Select Id</h3>
                      <Form.Control
                        as="select"
                        className="text_link bulk_select"
                        // value={certi.certificateId}
                        onChange={(e) => {
                          handleChange(e.target.value);
                        }}
                      >
                        <option>Select Id</option>

                        {certis.map((cert, i) => {
                          return (
                            <option
                              value={i}
                              key={i}
                              selected={
                                certificate_id && certificate_id != ""
                                  ? certificate_id == cert.certificateId
                                    ? true
                                    : false
                                  : false
                              }
                            >
                              {cert.certificateId}, {cert.certificateTitle}
                            </option>
                          );
                        })}
                      </Form.Control>
                    </Form.Group>

                    <div className="upload_btn_wrapper">
                      <h3>Upload Certificate</h3>
                      <p>Only CSV file supported</p>
                      <button className="btn_bulk">
                        <span className="cert_bulkks">
                          <img src={CertDet2} alt="" />
                        </span>
                        {file !== "" ? file.name : "Upload Certificates"}
                      </button>
                      <input
                        type="file"
                        name="myfile"
                        onChange={(e) => {
                          setFile(e.target.files[0]);
                        }}
                      />
                    </div>
                    <p className="ml-3">
                      <a
                        href={sampleFile}
                        download={true}
                        className="btn btn-primary btn-sm"
                      >
                        Download Sample File
                      </a>
                    </p>
                    <div className="sub_but">
                      <button
                        type="submit"
                        onClick={uploadBadge}
                        className="add_but submit_buttt mt-0"
                      >
                        Submit
                      </button>
                    </div>
                  </Col>
                </Row>

                <div className="ar_count_card d-flex mt-5">
                  <h3>All Certificates Codes</h3>
                  <div className="ar_count">{pagination.totalRows}</div>
                </div>

                <div className="filter_section">
                  <div className="input-group filter_fields">
                    <div className="search_field">
                      <input
                        placeholder="Type Certificate ID, code"
                        type="text"
                        id="form1"
                        className="form-control"
                        onChange={(e) => {
                          setQuery(e.target.value);
                        }}
                        value={query}
                      />
                    </div>

                    <Button
                      className="search_button"
                      variant="primary"
                      onClick={() => {
                        setSearch(query);
                        setPage(1);
                      }}
                    >
                      Search
                    </Button>

                    <Button
                      className="search_button"
                      variant="secondary"
                      disabled={!search}
                      onClick={() => {
                        setSearch("");
                        setQuery("");
                        setPage(1);
                      }}
                    >
                      Clear Filter
                    </Button>
                  </div>
                  <div className="filter_btns">
                    <Button
                      className="btn btn-primary search_button"
                      onClick={exportCSV}
                    >
                      Export CSV
                    </Button>
                    <CSVLink
                      data={csvData}
                      headers={csvHeaders}
                      filename={`all_certificate_code.csv`}
                      className="hidden"
                      id="csv-download-link"
                      target="_blank"
                    />
                  </div>
                </div>

                <DataTable
                  title="All Certificates Codes"
                  columns={columns}
                  data={allCodes}
                  highlightOnHover
                  pagination
                  striped
                  responsive
                  paginationDefaultPage={page}
                  paginationServer
                  paginationTotalRows={pagination.totalRows}
                  paginationPerPage={limit}
                  paginationRowsPerPageOptions={[10, 15, 20, 40]}
                  onChangeRowsPerPage={handlePerRowsChange}
                  onChangePage={changePage}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </LoadingOverlay>
    //     </div>
    // </div>
  );
};

export default BulkUpload;
